import {useState} from 'react';
import cn from 'classnames';

import More from '@/root/components/More';
import {ROUTES} from '@/root/constants/routes';
import {RecommendedCardBanners} from '@/root/models/home';
import {useUiStore} from '@/root/stores/ui';

import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';
import useAdvancedNavigate from '@/shared/hooks/useAdvancedNavigate';
import useTiara from '@/shared/hooks/useTiara';

type Props = {
  cards: RecommendedCardBanners[];
};

const MIN_LENGTH = 4;

const RecommendCards = ({cards}: Props) => {
  const {isRecommendCardsVisible, setIsRecommendCardsVisible} = useUiStore();
  const [visibleCount, setVisibleCount] = useState(isRecommendCardsVisible ? cards.length : MIN_LENGTH);
  const navigate = useAdvancedNavigate();
  const {trackEvent} = useTiara({pageName: TIARA_PAGE_NAME.HOME});

  const onClickMore = () => {
    trackEvent({action: TIARA_ACTION.RECOMMEND_MORE_CLICK});
    setVisibleCount(cards.length);
    setIsRecommendCardsVisible(true);
  };

  const onClickCard = ({title, recommendCode, isCustom, isNew}: RecommendedCardBanners) => {
    trackEvent({
      action: TIARA_ACTION.RECOMMEND_CARD_CLICK,
      customProps: {title, isCustom: `${isCustom}`, isNew: `${isNew}`}
    });
    navigate(ROUTES.RECOMMEND_CODE, {pathParams: {recommendCode}});
  };

  return (
    <>
      <h3 className="tit_section type2">
        <span role="text">
          <span className="txt_tit">발급 추천카드</span>
        </span>
      </h3>
      <ul className="list_recommend">
        {cards.slice(0, visibleCount).map((card) => (
          <li key={card.title} className="item_recommend">
            <button
              type="button"
              className={cn('btn_recommend')}
              disabled={card.isMaintenance}
              onClick={() => onClickCard(card)}
            >
              <span className="box_recommend">
                <span className="thumb_card" style={{backgroundImage: `url(${card.thumbnailUrl})`}} />
                <span className="cont_info">
                  <strong className="tit_recommend" role="text">
                    <span className="txt_tit">{card.title}</span>
                    {(card.isNew || card.isCustom) && <span className="screen_out">, </span>}
                    {card.isNew && !card.isCustom && <span className="badge_g2 type2">신규</span>}
                    {card.isCustom && <span className="badge_g2 type1">맞춤</span>}
                  </strong>
                  <span className="txt_recommend" role="text">
                    {card.subTitle}
                  </span>
                </span>
                <span className="txt_issue">{card.isMaintenance ? '점검' : '발급'}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
      <More show={cards.length > visibleCount} text="추천 더보기" onClickMore={onClickMore} direction="down" />
    </>
  );
};

export default RecommendCards;
